<section class="archive-panel">
  <header class="archive-head">
    <h2>Archivio {{ archive_type == 0 ? 'temporaneo' : 'permanente' }}</h2>
    @if (archive_type == 0) {
      <button class="archive-refresh" type="button" (click)="refresh()" aria-label="Aggiorna archivio temporaneo">
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
      </button>
    }
  </header>

  @if (folders.length || files.length) {
    <ul class="archive-list">
      @for (folder of folders; track folder) {
        <app-folder [archive_type]="archive_type" [folderName]="folder" [path]="path"
          (saveArticle_folder)="saveArticle($event)"></app-folder>
      }
      @for (file of files; track file) {
        <li class="file-row" [title]="file.modified">
          <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
          <span>{{ file.name }}</span>
          <span class="file-size">{{ file.size }} MB</span>
        </li>
      }
    </ul>
  } @else if (hasLoaded) {
    <p class="archive-empty">Nessun elemento in questo archivio.</p>
  }
</section>
